(() => {
  const getRoutes = () => {
    const configured = window.MaHawaRoutes || {};
    return {
      home: configured.home || '/?view=home',
      products: configured.products || '/'
    };
  };

  const normalisePath = (path) => {
    const value = String(path || '/').replace(/\/+$/, '');
    return value || '/';
  };

  const isLegacyProductsPath = (path) => {
    const clean = normalisePath(path);
    return /\/collections(?:\/(?:all|products))?$/.test(clean) || /\/pages\/our-products$/.test(clean);
  };

  const isProductContextPath = (path) => {
    const clean = normalisePath(path);
    return /\/collections(?:\/|$)/.test(clean) || /\/products(?:\/|$)/.test(clean) || isLegacyProductsPath(clean);
  };

  const setHref = (link, href) => {
    if (link && href && link.getAttribute('href') !== href) link.setAttribute('href', href);
  };

  const markHeaderHomeLinks = (scope, homeHref) => {
    const selectors = [
      '.menu-drawer__navigation > .menu-drawer__menu > li:first-child > a',
      '.header__inline-menu .list-menu--inline > li:first-child > a'
    ];

    scope.querySelectorAll(selectors.join(',')).forEach((link) => {
      link.dataset.mahawaDestination = 'home';
      setHref(link, homeHref);
    });
  };

  const rewriteLinks = (scope = document) => {
    const routes = getRoutes();
    const homeUrl = new URL(routes.home, window.location.origin);
    const productsUrl = new URL(routes.products, window.location.origin);
    const homeHref = homeUrl.pathname + homeUrl.search;
    const productsHref = productsUrl.pathname + productsUrl.search;

    markHeaderHomeLinks(scope, homeHref);

    scope.querySelectorAll('a[href]').forEach((link) => {
      if (link.dataset.mahawaDestination === 'home') {
        setHref(link, homeHref);
        return;
      }

      let target;
      try { target = new URL(link.getAttribute('href'), window.location.origin); }
      catch (error) { return; }
      if (target.origin !== window.location.origin) return;

      const targetPath = normalisePath(target.pathname);
      const targetView = target.searchParams.get('view');
      const sameHomePath = targetPath === normalisePath(homeUrl.pathname);
      const sameProductsPath = targetPath === normalisePath(productsUrl.pathname);
      const bareGlobalRoot = targetPath === '/' && targetView !== 'home';

      if (sameHomePath && targetView === 'home') {
        setHref(link, homeHref);
        return;
      }

      if (isLegacyProductsPath(target.pathname) || (sameProductsPath && targetView !== 'home') || bareGlobalRoot) {
        setHref(link, productsHref);
      }
    });

    scope.querySelectorAll('.header__heading-link').forEach((link) => setHref(link, productsHref));

    scope.querySelectorAll('.ma-hawa-mobile-nav').forEach((nav) => {
      const items = nav.querySelectorAll('.ma-hawa-mobile-nav__item');
      setHref(items[0], homeHref);
      setHref(items[1], productsHref);

      const current = normalisePath(window.location.pathname);
      const currentView = new URLSearchParams(window.location.search).get('view');
      let active = null;

      if (current === normalisePath(homeUrl.pathname) && currentView === 'home') active = items[0];
      else if (/\/collections\/machines$/.test(current)) active = items[2];
      else if (/\/cart$/.test(current)) active = items[3];
      else if (current === normalisePath(productsUrl.pathname) || isProductContextPath(current)) active = items[1];

      if (active) {
        items.forEach((item) => {
          item.classList.remove('is-active');
          item.removeAttribute('aria-current');
        });
        active.classList.add('is-active');
        active.setAttribute('aria-current', 'page');
      }
    });
  };

  const syncDrawerState = () => {
    const drawers = [...document.querySelectorAll('header-drawer > details')];
    const update = () => document.body.classList.toggle('mahawa-menu-open', drawers.some((drawer) => drawer.open));
    drawers.forEach((drawer) => {
      if (drawer.dataset.mahawaLayerBound === 'true') return;
      drawer.dataset.mahawaLayerBound = 'true';
      drawer.addEventListener('toggle', update);
    });
    update();
  };

  const redirectToCanonicalProducts = () => {
    const currentPath = normalisePath(window.location.pathname);
    if (!isLegacyProductsPath(currentPath)) return false;

    const target = new URL(getRoutes().products, window.location.origin);
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.delete('view');
    currentParams.forEach((value, key) => target.searchParams.append(key, value));
    target.hash = window.location.hash;

    const destination = target.pathname + target.search + target.hash;
    const current = window.location.pathname + window.location.search + window.location.hash;
    if (destination === current) return false;

    window.location.replace(destination);
    return true;
  };

  const initialize = (scope = document) => {
    if (redirectToCanonicalProducts()) return;
    rewriteLinks(scope);
    syncDrawerState();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('pagehide', () => document.body.classList.remove('mahawa-menu-open'));
})();
